import instagram from "@/assets/instagram.svg";
import logo from "@/assets/app-logo.svg";
import logoText from "@/assets/pulse-text-logo.svg";
import { NavLink } from "react-router-dom";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import { openInstagramProfile } from "@/lib/openExternal";

const HeaderWithInstagram = () => {
  const isStandalone = useStandaloneMode();
  if (isStandalone) {
    return null;
  }

  return (
    <header className="flex justify-between items-center px-4 md:px-8 py-5 bg-black text-white">
      <div className="flex items-center">
        <NavLink to="/">
          <img
            src={logo}
            alt="Pulse Logo"
            className="w-7 h-7 md:w-8 md:h-8 mr-2 transition-transform duration-300 hover:scale-125"
          />
        </NavLink>
        <img src={logoText} alt="Pulse Logo" className="w-14 md:w-16" />
      </div>
      <button
        type="button"
        onClick={() => openInstagramProfile("pulsedating")}
        className="transition-transform duration-300 hover:scale-110"
        aria-label="Open Pulse on Instagram"
      >
        <img src={instagram} alt="Instagram Logo" className="w-6 h-6" />
      </button>
    </header>
  );
};

export default HeaderWithInstagram;
